import {
  Box,
  FormControl,
  InputLabel,
  Link,
  Select,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";

export const BigTitleStyled = styled("h1")(() => ({
  width: "fit-content",
  fontFamily: "Roboto",
  fontSize: "18px",
  fontWeight: "600",
  margin: 0,
}));

export const TitleStyled = styled("h2")(() => ({
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: "600",
  margin: 0,
}));

export const NormalText = styled("p")(
  ({
    size = 12,
    color = "#8C8C8C",
    isBold = false,
    letterSpacing = "inherit",
  }) => ({
    width: "fit-content",
    fontFamily: "Roboto",
    fontSize: `${size}px`,
    margin: 0,
    color: color,
    fontWeight: isBold ? "bold" : "normal",
    letterSpacing: letterSpacing,
  })
);

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiInputBase-root": {
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.grey[1]}`,
    borderRadius: "4px",
    "&.Mui-focused": {
      border: "1px solid #0197f6 !important",
    },
  },
  "& .MuiInputBase-input": {
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "14px",
    backgroundColor: "#F5F5F5",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiFormLabel-root": {
    top: "-8px",
    left: "-8px",
  },
}));

export const LinkStyled = styled(Link)(() => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  width: "fit-content",
  color: "#0197f6",
  fontSize: "12px",
  textDecoration: "none",
  transition: "0.2s",
  "&:hover": {
    color: "#8C8C8C",
  },
}));

export const TableBodyStyled = styled(TableBody)(() => ({
  ".MuiTableRow-root td:first-child": {
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
  },
  ".MuiTableRow-root td:last-child": {
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
  },
}));

export const RowStyled = styled(TableRow)(() => ({
  backgroundColor: "#F5F5F5",
}));

export const TableHeadStyled = styled(TableHead)(() => ({
  "& .MuiTableCell-head": {
    borderRadius: "8px",
    color: "#0F110C",
    fontSize: "12px",
    padding: "0 32px",
    borderBottom: "none",
  },
}));

export const TableStyled = styled(Table)(() => ({
  borderSpacing: "0 4px",
  borderCollapse: "separate",
  overflowX: "auto",
  width: "100%",
}));

export const TableCellStyled = styled(TableCell)(() => ({
  color: "#8C8C8C",
  fontSize: "12px",
  borderBottom: "none",
  padding: "16px 8px",
}));

export const TooltipStyled = styled(Tooltip)(({ withCopy = false }) => ({
  userSelect: "none",
  ...(withCopy && {
    cursor: "pointer",
  }),
}));

export const SpanBold = styled("span")(() => ({
  fontWeight: "bold",
}));

export const FormControlStyled = styled(FormControl)(
  ({
    withMargin = false,
    withMarginLabel = true,
    width = "100%",
    theme,
    withBorder = true,
  }) => ({
    boxShadow: "none",
    color: "#0F110C",
    "& .MuiInputBase-root": {
      border: withBorder
        ? `1px solid ${theme.palette.grey[1]} !important`
        : "none !important",
      fontSize: "14px",
      color: "#202020",
      "& .MuiPaper-root": {
        borderRadius: "8px",
      },
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        gap: "8px",
      },
      svg: {
        color: theme.palette.neutral.black,
        width: "16px",
        height: "16px",
        position: "absolute !important",
        right: "16px !important",
      },
    },
    "& .MuiOutlinedInput-root": {
      boxShadow: "none",
      width: width,
      margin: withMargin ? "8px 0px" : 0,
      borderRadius: "8px",
      outline: 0,
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent",
          borderWidth: "2px",
        },
      },
      "&.MuiInputLabel-outlined": {
        "&.Mui-focused": {
          color: "#0197f6",
          fontWeight: "bold",
        },
      },
    },
    "&.MuiSelect-icon": {
      color: "#0197f6",
      "&.Mui-focused": {
        color: "#0197f6",
      },
    },
    "& .MuiInputLabel-root": {
      margin: withMarginLabel ? "-7px 0 0 0" : 0,
      "&.Mui-focused": {
        color: "#0197f6",
      },
    },
  })
);

export const InputLabelStyled = styled(InputLabel)(() => ({
  fontSize: "14px",
  color: "#9C9C9C",
  "&.Mui-focused": {
    color: "#0197f6",
  },
}));

export const SelectStyled = styled(Select)(({ theme }) => ({
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiList-root": {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    padding: 0,
    "& .MuiMenuItem-root": {
      fontSize: "14px",
      "&:hover": {
        backgroundColor: theme.palette.grey[3],
      },
    },
    "& .Mui-selected": {
      backgroundColor: theme.palette.grey[3],
      color: theme.palette.primary.main,
    },
  },
}));

export const ContainerCopyCell = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  justifyContent: "center",
}));
